<template>
  <div class="container">
    <div class="main" v-loading="loading">
    <div class="header">
        <div class="left">
          <div class="line-1"></div>
          <div class="line-2"></div>
          <span class="title">{{ id ? $t('editChild.edit') : $t('faultEdit.add') }}</span>
        </div>
        <div class="right">
          <el-button class="submit-btn" icon="el-icon-plus" @click="submitForm('ruleForm')">{{$t('login.submit')}}</el-button>
          <el-button class="back-btn" icon="el-icon-back" @click="returnBack">{{$t('applyChildDetail.return')}}</el-button>
        </div>
      </div>
    <div class="edit-box">
        <el-form :model="ruleForm" :rules="formRules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="故障编码" prop="alarmCode">
            <el-input v-model="ruleForm.alarmCode" show-word-limit  maxlength="2">\
              <template slot="prepend">0X</template>
            </el-input>
          </el-form-item>
          <el-form-item label="语言">
             <el-select v-model="languageType" >
              <el-option
                v-for="item in languageList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
             </el-select>
          </el-form-item>
          <el-form-item :label="$t('faultEdit.faultType')" >
            <el-input v-model="currentAlarmItem.alarmType" show-word-limit  maxlength="20"></el-input>
          </el-form-item>
          <el-form-item :label="$t('faultDetail.solveProgramme')">
            <el-input
            v-model="currentAlarmItem.solution"
            type="textarea" show-word-limit  maxlength="500"
            :autosize="{ minRows: 2, maxRows: 4}"
            :placeholder="$t('faultEdit.inputSolveProgramme')">
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('componentsReply.enclosure')">
            <el-upload
              class="upload-demo"
              :auto-upload="false"
              action=""
              :on-change="function(file, fileList) { return uploadFile(file, fileList, 'attachment') }"
              :on-preview="handlePreview"
              :on-remove="function(file, fileList) { return handleRemove(file, fileList, 'attachment') }"
              :before-remove="beforeRemove"
              multiple
              :limit="5"
              :on-exceed="handleExceed"
              :file-list="currentAlarmItem.attachment">
              <el-button size="small" type="primary">{{$t('componentsReply.uploadClick')}}</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item :label="$t('componentsReply.image')" prop="imgList">
            <el-upload
              class="upload-demo"
              action=""
              accept="image/jpg, image/png, image/jpeg"
              :auto-upload="false"
              :on-change="function(file, fileList) { return uploadFile(file, fileList, 'imgList') }"
              :on-preview="handlePreview"
              :on-remove="function(file, fileList) { return handleRemove(file, fileList, 'imgList') }"
              :file-list="ruleForm.imgList"
              :limit="5"
              list-type="picture">
              <el-button size="small" type="primary">{{$t('componentsReply.uploadClick')}}</el-button>
              <div slot="tip" class="el-upload__tip">{{$t('faultEdit.onlySupport')}}</div>
            </el-upload>
          </el-form-item>
          <el-form-item :label="$t('faultFilter.associatedProduct')" prop="relatedItems">
            <el-select
            v-model="ruleForm.relatedItems"
            multiple
            collapse-tags
            :loading="productLoading"
            v-scroll="handleScroll"
            @focus="getProduct"
            :placeholder="$t('faultFilter.choProduct')">
              <el-option
              v-for="item in productList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
              </el-option>
          </el-select>
          </el-form-item>
        </el-form>
    </div>
    </div>
  </div>
</template>

<script>
import { rules } from "./config"
import { uploadFile, getProductList } from "@/api/goods"
import {
  addNewCommonItem,
  addNewTempItem,
  commonDetail,
  tempDetail,
  editCommonItem,
  editTempItem
  } from "@/api/fault"
import { throttle } from "@/util/optimization"
  export default {
    data() {
      return {
        languageType: '100000',
        languageList: [
          { value: '100000', label: '中文' },
          { value: '100001', label: 'EN' },
          { value: '100002', label: 'TR' },
        ],
       ruleForm: {
        alarmCode: '',
        alarmList: [{languageType: '100000', alarmType: '', solution: '', attachment: []},
        {languageType: '100001', alarmType: '', solution: '', attachment: []},
        {languageType: '100002', alarmType: '', solution: '', attachment: []}],
        imgList: [],
        relatedItems: [],
        tenantId: ''
       },
       formRules: rules,
       productLoading: false,
       loading: false,
       canmore: true,
       productList: [],
       submitApi: null,
       editApi: null,
       detailApi: null
      }
    },
    computed: {
  currentAlarmItem() {
    const item = this.ruleForm.alarmList.find(x => x.languageType === this.languageType);
    return item || {};
  },
      id() {
        if(this.$route.query && this.$route.query.id) {
            return this.$route.query.id
        }
      },
      listReq() {
        return {
            current: 1,
            size: 10,
            total: 0
        }
      },
      type() {
        if(this.$route.meta && this.$route.meta.type) {
          return this.$route.meta.type;
        }
      },
      userInfo() {
        let userInfo_ = JSON.parse(window.localStorage.getItem('saber-userInfo'));
        if(userInfo_) {
          return userInfo_;
        }
      },
      postParams() {
        const processedAlarmList = this.ruleForm.alarmList.map(item => {
          return {
           languageType: item.languageType,
      alarmType: item.alarmType,
      solution: item.solution,
      attachName: item.attachment.length ? item.attachment.map(x => x.name).join(",") : "",
      attach: item.attachment.length ? item.attachment.map(x => x.url).join(",") : "",
      attachSize: item.attachment.length ? item.attachment.map(x => x.size).join(",") : "",
                    }
                });
        const _return = {
            alarmCode:this.ruleForm.alarmCode,
            alarmList: processedAlarmList,
            productList: this.ruleForm.relatedItems.length ? this.ruleForm.relatedItems : [],
            photo: this.ruleForm.imgList.length ? this.ruleForm.imgList.map(x => x.url).join(",") : '',
            tenantId: this.userInfo ? this.userInfo.content.tenant_id : '',
            id: this.id
        };
        return _return;
      },
    },
    created() {
     if(this.id) {
      this.getDetail();
     }
    },
    methods: {
      handleSubmitApiChange(e) {
        switch(e) {
          case 'common':
            return addNewCommonItem;
          case 'temp':
            return addNewTempItem;
        }
      },
      handleDetailApiChange(e) {
        switch(e) {
          case 'common':
            return commonDetail;
          case 'temp':
            return tempDetail;
        }
      },
      handleEditApiChange(e) {
        switch(e) {
          case 'common':
            return editCommonItem;
          case 'temp':
            return editTempItem;
        }
      },
      // 滚动加载更多
      handleScroll() {
         if(this.canmore) {
            this.clickThrottle();
         }
      },
      // 节流加载
      clickThrottle: throttle(function (event) {
        this.getProduct();
      }, 1000),
      // 获取产品
      async getProduct() {
        this.productLoading = true;
        const res = await getProductList(this.listReq);
        console.log('product =>', res);
        if(res.data && res.data.code === 200) {
            if(res.data.data.records.length > 0) {
                this.listReq.current++;
                this.productList = this.productList.concat(res.data.data.records);
            } else {
                this.canmore = false;
            }
        }
        this.productLoading = false;
      },
      handleRemove(file, fileList, target) {
        let currentIndex;
        this.ruleForm[target].map((x,idx) => {
          if(file.uid === x.uid) {
            currentIndex = idx;
          }
        })
        this.ruleForm[target].splice(currentIndex, 1);
        console.log(this.ruleForm[target], target);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {
        this.$message.warning(this.$t('faultEdit.limitThreeFail') + `${files.length}`+ this.$t('faultEdit.totalCho') + `${files.length + fileList.length}` + this.$t('componentsReply.individualFile'));
      },
      beforeRemove(file, fileList) {
        return this.$confirm(this.$t('componentsReply.sureRemove') +`${ file.name }？`);
      },
      async uploadFile(file, fileList, target) {
        console.log('file', file);
        console.log('target', target)
        let fileList1 = [];
        let FormDatas = new FormData()
        FormDatas.append('file',file.raw);
        let { data } = await uploadFile(FormDatas);
        console.log('data', data)
        if(data && data.code === 200) {
          this.$message.success(this.$t('AAAA.uploadSuccess'))
          let obj = {
            domain: data.data.domain,
            status: "success",
            name: data.data.originalName,
            size: file.size,
            url: data.data.link,
          }
          this.ruleForm[target].push(obj)
        } else {
          for(var i = 0; i < fileList1.length; i++){
            if(i + 1 == fileList1.length){
              fileList1.splice(i,1)
            }
          }
          this.$message.error(data.msg)
          return
        }
      },
      returnBack() {
         this.$EvenBus.$emit('menuTag', this.$route.fullPath, 'remove');
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          console.log(this.postParams);
          if (valid) {
            if(this.id) {
              this.edit();
            } else {
              this.submit();
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 新增
      async submit() {
        console.log(this.postParams,'postParams');
        this.loading = true;
        try {
          this.submitApi = this.handleSubmitApiChange(this.type);
          const res = await this.submitApi(this.postParams);
          console.log('res =>', res.data);
          if (res.data && res.data.code === 200) {
            this.$message.success(this.$t('componentsReply.addSuccess'))
            setTimeout(() => {
              this.returnBack()
            }, 1000)
          } else {
            this.$message.error(res.data.msg);
          }
        } finally {
          this.loading = false
        }
      },
      // 编辑
      async edit() {
        console.log(this.postParams);
        this.loading = true;
        try {
          this.editApi = this.handleEditApiChange(this.type);
          const res = await this.editApi(this.postParams);
          if (res.data && res.data.code === 200) {
            this.$message.success(this.$t('faultEdit.editSuccess'))
            setTimeout(() => {
              this.returnBack()
            }, 1000)
          } else {
            this.$message.error(res.data.msg);
          }
        }finally {
          this.loading = false
        }
      },
      // 编辑回显
      async getDetail() {
        try {
          this.loading = true;
          this.detailApi = this.handleDetailApiChange(this.type);
          const res = await this.detailApi(this.id);
          console.log('res =>', res.data);
          if(res.data && res.data.code === 200) {
            this.clickThrottle();
            this.ruleForm.alarmCode = res.data.data.alarmCode;
            this.ruleForm.alarmType = res.data.data.alarmType;
            this.ruleForm.solution = res.data.data.solution;
            res.data.data.attach && res.data.data.attach.split(",").map((x, idx) => {
              this.ruleForm.attachment.push({
                name: res.data.data.attachName.split(",")[idx],
                size: res.data.data.attachSize.split(",")[idx],
                url: x
              })
            })
            res.data.data.photo && res.data.data.photo.split(",").map((v, idx) => {
              this.ruleForm.imgList.push({
                url: v
              })
            })
            this.ruleForm.relatedItems = res.data.data.productList.length ? res.data.data.productList.map(p => p.id) : [];
          }
          this.loading = false;
        } catch(e) {
          this.$message.error(e.toString());
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
.main {
  background-color: #fff;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    padding: 0 21px;
    .left {
      display: flex;
      align-items: center;
      .line-1 {
        width: 4px;
        height: 18px;
        background: #01AAA7;
        border-radius: 2px;
      }
      .line-2 {
        margin-left: 2px;
        width: 2px;
        height: 18px;
        background: #01AAA7;
        border-radius: 1px;
      }
      .title {
        margin-left: 9px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
    }
    .right {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      .submit-btn {
        background-color: #01AAA7;
        color: #fff;
      }
      .back-btn {
        color: #01AAA7;
        border-color: #01AAA7;
      }
    }
  }
  .edit-box {
    width: 600px;
    padding: 23px 0;
    margin: 0 auto;
  }
}
</style>
